<template>
    <div class="auto-complete" :class="{loading: loading}">
        <div class="">
            <label :for="name" class="relative display-block" :class="{ 'blurred': this.blurred }">
                {{label}} <span
                            v-if="tooltipText !== null"
                            style="font-size: 1rem"
                            class="fa fa-info-circle text-blue"
                            v-tooltip="tooltipText"
                        ></span>
                <button
                    type="button"
                    class="btn btn-xs btn-warning pull-right"
                    v-if="model && themeColor"
                    :style="'background-color: ' + themeColor + '; right: 0px;'"
                    @click="setModel(null)"
                >
                  <span>Remove Unit</span>
                </button>
                <button
                    type="button"
                    class="btn btn-xs btn-warning pull-right"
                    style="right: 0px;"
                    v-else-if="model"
                    @click="setModel(null)"
                >
                    <span>Remove Unit</span>
                </button>
            </label>

            <div :class="{ 'blurred': this.blurred }">
                <input class="search-input form-control"
                       v-model="search"
                       :placeholder="[[ placeholder ]]"
                       @focus="setSearchFocus(true)"
                       :disabled="model_id || this.blurred"
                       @blur="handleBlur"
                       v-on:keyup="keyupHandler( $event )">
            </div>

            <input class="form-control active-hidden"
                   type="text"
                   v-model="model_id"
                   :name="name"
                   :required="required"
                   :aria-required="required">
        </div>

        <div :class="resultsClass" v-if="showResults">
            <div class="model" v-for="currentModel in models" v-on:click="setModel( currentModel )">
                <slot v-bind="currentModel" name="model-display">
                    {{currentModel}}
                </slot>
            </div>

            <div class="no-results" v-if="models && models.length === 0 && showNoResultsMessage">
                <h5>No Results Found</h5>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            resultsLimit: {
                type: Number,
                default: 100
            },
            themeColor: {
                type: String,
                default: null
            },
            blurred: {
                type: Boolean,
                default: false
            },
            label: {
                type: String,
                default: 'Search'
            },
            placeholder: {
              type: String,
              default: 'Search'
            },
          resultsClass: {
            type: String,
            default:'search-results'
          },
            tooltipText: {
                type: [String, null],
                default: null
            },
            name: {
                type: String,
                required: true
            },
            required: {
                type: Boolean,
                default: false
            },
            resourceUrl: {
                type: String,
                required: true
            },
            queryString: {
                type: String,
                default: ''
            },
            initialId: {
                type: String,
                default: null
            },
            findResultIndex: {
                type: String,
                default: null
            },
            searchResultsIndex: {
                type: String,
                default: null
            },
            showNoResultsMessage: {
              type: Boolean,
              default: true
            },
        },
        data(){
            return {
                loading: true,
                loadingModels: false,
                models: [],
                oldModel: null,
                model: null,
                search: null,
                searchFocus: false,
            }
        },

        mounted(){
            this.init();
        },

        computed: {
            showResults(){
                return this.searchFocus;
            },
            model_id(){
                return _.get( this.model, 'id' );
            }
        },

        watch: {
            search: _.debounce( function(){
                this.loadingModels = true;

                this.loadModels()
                    .then( () => {
                        this.loadingModels = false;
                    } )
            }, 380, {
                trailing: true
            } ),

            model( model ){
                // Reset the validator instance when setting the model
                var form = $( this.$el ).parents( 'form._validate:first' );

                if( form.length ){
                    var validator = form.data( 'validator' );

                    if( validator ){
                        validator.resetForm();
                    }
                }

                // Set the search text from the model-display slot
                if( model ){
                    this.search = this.getModelDisplayText( model );
                }
                else {
                    this.search = null;
                }
            },

            blurred( blurred ) {
                this.model = null;
            },

            model_id(){
                if (!this.blurred) {
                    this.$emit( 'change', this.model_id, this.model );
                }
            },

            initialId(){
                if (!this.blurred) {
                    this.loadModel();
                }
            }
        },
        methods: {
            init(){
                this.loadModel()
                    .catch( ( err ) => {
                        return this.$root.handleErrors( err );
                    } )
                    .finally( ( resident ) => {
                        this.loading = false;
                    } );
            },

            getModelDisplayText( model ){
                var displayText = this.$scopedSlots[ 'model-display' ]( model )[ 0 ].text;

                if( typeof displayText === 'string' ){
                    return displayText.trim();
                }
            },

            setModel( model ){
                this.model = model;
                this.searchFocus = false;
            },

            handleBlur() {
                this.$emit('keyup', '');
                this.$emit('keyup', '');
                setTimeout( function() {
                    this.setModel(this.model);
                    if ( !this.model ) {
                        this.search = '';
                    }
                }.bind(this), 200);
            },

            keyupHandler( event ) {
                this.$emit('keyup', event.key);
            },

            loadModel(){
                if( !this.initialId ){
                    return Promise.resolve( null );
                }

                return axios.get( this.resourceUrl + '/' + this.initialId )
                    .then( ( response ) => {
                        if( this.findResultIndex ){
                            this.setModel( _.get( response.data, this.findResultIndex ) );
                        }
                        else {
                            this.setModel( response.data );
                        }
                    } );
            },

            loadModels(){
                var url = this.resourceUrl;
                if( !url.includes( '?' ) ){
                    url += '/?';
                }

                url += `&limit=${this.resultsLimit}`;

                if( this.queryString ){
                    url += '&' + this.queryString;
                }

                if( this.showResults ){
                    url += '&q=' + (this.search === null ? '' : this.search);
                }

                return axios.get( url )
                    .then( ( response ) => {
                        if( this.searchResultsIndex ){
                            if( !_.has( response.data, this.searchResultsIndex ) ){
                                console.error( 'Unrecognized searchResultsIndex' );
                            }

                            this.models = _.get( response.data, this.searchResultsIndex );
                        }
                        else {
                            this.models = response.data;
                        }
                    } );
            },

            setSearchFocus( value ){
                this.searchFocus = value;
                this.loadingModels = true;

                this.loadModels()
                    .then( () => {
                        this.loadingModels = false;
                    } )
            },

            reset(){
                Object.assign( this.$data, this.$options.data() );

                this.init();
            }
        }
    }
</script>
